import dotProp from 'dot-prop-immutable';

import * as types from '../actionTypes';

const defaultState = {
  mathBet: {
    data: undefined,
    error: undefined,
    loading: false,
  },
  settings: {
    data: undefined,
    error: undefined,
    loading: false,
  },
};

export default function reducer(state = defaultState, action = {}) {
  switch (action.type) {
    // math bet
    case types.REQUEST_CREATE_MATHBET:
      return {
        ...state,
        mathBet: {
          ...defaultState.mathBet,
          loading: true,
        },
      };

    case types.RECEIVE_CREATE_MATHBET:
      return {
        ...state,
        mathBet: {
          ...defaultState.mathBet,
          data: action.payload,
        },
      };

    case types.RECEIVE_CREATE_MATHBET_ERROR:
      return {
        ...state,
        mathBet: {
          ...defaultState.mathBet,
          error: action.payload,
        },
      };

    // wizard settings

    case types.REQUEST_WIZ_SETTINGS:
      return dotProp.set(state, 'settings', {
        ...defaultState.settings,
        loading: true,
      });

    case types.RECEIVE_WIZ_SETTINGS:
      return dotProp.set(state, 'settings', {
        ...defaultState.settings,
        data: action.payload,
      });

    case types.RECEIVE_WIZ_SETTINGS_ERROR: {
      const { errorType } = action.meta;

      return dotProp.set(state, 'settings', {
        ...defaultState.settings,
        error: errorType,
      });
    }

    default:
      return state;
  }
}
